// extracted by mini-css-extract-plugin
export default {"link":"MigratedBeanContent_link__i0gvh","currentBidCol":"MigratedBeanContent_currentBidCol__5Fu2s","bidRow":"MigratedBeanContent_bidRow__vK93E"};